(function () {
	var resizeObservers = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

	function getSlidesForEqualize(swiper) {
		var all = swiper.slides;
		var out = [];
		var i;
		for (i = 0; i < all.length; i++) {
			if (!all[i].classList.contains('swiper-slide-duplicate')) {
				out.push(all[i]);
			}
		}
		return out.length ? out : all;
	}

	// Store equalized heights per slider
	var equalizedHeightsMap = new WeakMap();
	var heightAppliedMap = new WeakMap();

	function equalizeClubCardHeights(swiper, forceRecalc) {
		var section = swiper.el.closest('.club-cards-slider');
		if (!section || section.classList.contains('club-cards-slider--overlap')) return;

		if (!forceRecalc && equalizedHeightsMap.has(swiper.el)) {
			var cachedHeight = equalizedHeightsMap.get(swiper.el);
			if (cachedHeight > 0 && !heightAppliedMap.get(swiper.el)) {
				applyHeightsToAllSlides(swiper, cachedHeight);
				heightAppliedMap.set(swiper.el, true);
			}
			return;
		}

		var slides = getSlidesForEqualize(swiper);
		var i;

		for (i = 0; i < slides.length; i++) {
			var c = slides[i].querySelector('.club-card');
			if (c) c.style.minHeight = '';
		}

		setTimeout(function () {
			if (!slides.length) return;
			
			var maxH = 0;
			for (i = 0; i < slides.length; i++) {
				var card = slides[i].querySelector('.club-card');
				if (card) {
					var h = Math.max(card.offsetHeight, card.scrollHeight);
					maxH = Math.max(maxH, h);
				}
			}
			
			equalizedHeightsMap.set(swiper.el, maxH);
			applyHeightsToAllSlides(swiper, maxH);
			heightAppliedMap.set(swiper.el, true);
			
		}, 50);
	}

	function applyHeightsToAllSlides(swiper, height) {
		if (height <= 0) return;
		
		for (var i = 0; i < swiper.slides.length; i++) {
			var card = swiper.slides[i].querySelector('.club-card');
			if (card) {
				card.style.minHeight = height + 'px';
			}
		}
	}

	function whenImagesReadyForEqualize(swiper, callback) {
		var root = swiper.el;
		var imgs = root.querySelectorAll('img');
		var n = 0;
		var done = function () {
			n += 1;
			if (n >= imgs.length) callback();
		};
		if (!imgs.length) {
			callback();
			return;
		}
		for (var i = 0; i < imgs.length; i++) {
			if (imgs[i].complete) done();
			else {
				imgs[i].addEventListener('load', done, { once: true });
				imgs[i].addEventListener('error', done, { once: true });
			}
		}
	}

	function getSwiperOptions(swiperEl) {
		const section = swiperEl.closest('.club-cards-slider');
		if (!section) return null;
	
		const slideCount = parseInt(section.dataset.slideCount || '0', 10) || swiperEl.querySelectorAll('.swiper-slide').length;
		const peekNext = section.dataset.peekNext !== 'false';
		const peekOffsetDesktop = 0.28;
	
		const slidesPerViewDesktopBase = parseFloat(section.dataset.slidesPerView || '3') || 3;
		const slidesPerViewTablet = parseFloat(section.dataset.slidesPerViewTablet || '2') || 2;
		const slidesPerViewMobile = parseInt(section.dataset.slidesPerViewMobile || '1', 10) || 1;
		const loopRequested = section.dataset.loop === 'true';
	
		const slidesPerViewDesktop = peekNext ? slidesPerViewDesktopBase + peekOffsetDesktop : slidesPerViewDesktopBase;
	
		const maxSpv = Math.max(slidesPerViewDesktop, slidesPerViewTablet, slidesPerViewMobile);
		const minSlidesForLoop = Math.ceil(maxSpv * 2) + 4;
		const useLoop = loopRequested && slideCount >= minSlidesForLoop;
	
		const prevBtn = section.querySelector('.club-cards-slider__nav-prev');
		const nextBtn = section.querySelector('.club-cards-slider__nav-next');
	
		const opts = {
			loop: useLoop,
			// Minimal speed for quick snap after momentum
			speed: 200, // Fast snap to position
			roundLengths: true,
			grabCursor: true,
			watchSlidesProgress: true,
			observer: false,
			observeParents: false,
			
			// OPTIMIZED freeMode for instant but smooth inertia
			freeMode: {
				enabled: true,
				momentum: true,
				// REDUCE momentum ratio for less delay
				momentumRatio: 0.5, // Was 0.8 - lower = less inertia delay
				momentumVelocityRatio: 0.8, // Reduce velocity impact
				momentumBounce: true,
				momentumBounceRatio: 0.2, // Minimal bounce
				sticky: false,
				// Add minimum velocity to start momentum
				momentumMinimumVelocity: 0.1, // Ignore very slow movements
			},
			
			// ZERO threshold for instant response
			threshold: 0,
			
			// Touch settings for maximum responsiveness
			touchRatio: 1.3, // Slightly higher for quicker response
			touchAngle: 45,
			simulateTouch: true,
			longSwipes: false,
			shortSwipes: true,
			followFinger: true,
			
			// Edge settings
			touchReleaseOnEdges: false,
			resistance: true,
			resistanceRatio: 0.85,
			
			slidesPerView: slidesPerViewMobile,
			spaceBetween: 16,
			watchOverflow: false,
			slidesPerGroup: 1,
			
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
			},
			
			breakpoints: {
				576: {
					slidesPerView: slidesPerViewTablet,
					spaceBetween: 20,
					freeMode: {
						enabled: true,
						momentum: true,
						momentumRatio: 0.5,
						momentumVelocityRatio: 0.8,
						sticky: false,
					},
				},
				990: {
					slidesPerView: slidesPerViewDesktop,
					spaceBetween: 24,
					freeMode: {
						enabled: true,
						momentum: true,
						momentumRatio: 0.5,
						momentumVelocityRatio: 0.8,
						sticky: false,
					},
				},
			},
			on: {
				init: function (sw) {
					if (sw.wrapperEl) {
						// Use ease-out for quick stop
						sw.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'; // Quick ease-out
						sw.wrapperEl.style.willChange = 'transform';
					}
					sw.wrapperEl.style.scrollBehavior = 'auto';
					sw.el.style.overflow = 'hidden';
					sw.el.style.touchAction = 'pan-y pinch-zoom';
					
					whenImagesReadyForEqualize(sw, function () {
						setTimeout(function() {
							heightAppliedMap.set(sw.el, false);
							equalizeClubCardHeights(sw, true);
						}, 150);
					});
					
					if (document.fonts && document.fonts.ready) {
						document.fonts.ready.then(function () {
							setTimeout(function() {
								heightAppliedMap.set(sw.el, false);
								equalizeClubCardHeights(sw, true);
							}, 100);
						});
					}
				},
				
				// CRITICAL: Override momentum calculation for instant feedback
				touchMove: function (sw, event) {
					// Remove transition during drag for instant movement
					sw.wrapperEl.style.transition = 'none';
				},
				
				touchEnd: function (sw, event) {
					// Calculate if we need momentum
					const velocity = sw.velocity || 0;
					
					// If velocity is high, use momentum but with faster transition
					if (Math.abs(velocity) > 0.3) {
						sw.wrapperEl.style.transition = 'transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
					} else {
						// For low velocity, snap immediately
						sw.wrapperEl.style.transition = 'transform 0.15s cubic-bezier(0.25, 0.1, 0.25, 1)';
					}
				},
				
				// Add momentum transition end handler
				momentumBounce: function (sw) {
					// Ensure smooth bounce ends
					setTimeout(function() {
						if (sw.wrapperEl) {
							sw.wrapperEl.style.transition = '';
						}
					}, 200);
				},
				
				// Force snap after momentum
				slideChangeTransitionEnd: function (sw) {
					sw.wrapperEl.style.transition = '';
					if (!heightAppliedMap.get(sw.el)) {
						equalizeClubCardHeights(sw, true);
					}
				},
				
				resize: function (sw) {
					if (sw._resizeTimer) clearTimeout(sw._resizeTimer);
					sw._resizeTimer = setTimeout(function() {
						sw._resizeTimer = null;
						equalizedHeightsMap.delete(sw.el);
						heightAppliedMap.set(sw.el, false);
						equalizeClubCardHeights(sw, true);
					}, 200);
				},
				
				breakpoint: function (sw) {
					equalizedHeightsMap.delete(sw.el);
					heightAppliedMap.set(sw.el, false);
					setTimeout(function () {
						equalizeClubCardHeights(sw, true);
					}, 200);
				},
			},
		};
	
		if (useLoop) {
			opts.loopedSlides = slideCount;
			opts.loopAdditionalSlides = Math.min(slideCount, 6);
			opts.loopPreventsSlide = true;
		}
	
		return opts;
	}

	function initOneSwiper(swiperEl) {
		if (typeof Swiper === 'undefined') return;

		if (swiperEl.swiper) {
			if (resizeObservers && resizeObservers.has(swiperEl)) {
				resizeObservers.get(swiperEl).disconnect();
				resizeObservers.delete(swiperEl);
			}
			swiperEl.swiper.destroy(true, true);
		}

		const options = getSwiperOptions(swiperEl);
		if (!options) return;

		var layoutTries = 0;
		var maxLayoutTries = 10;

		function mountWhenLaidOut() {
			var w = swiperEl.getBoundingClientRect().width;
			if (w < 64 && layoutTries < maxLayoutTries) {
				layoutTries += 1;
				requestAnimationFrame(mountWhenLaidOut);
				return;
			}
		
			var swiper = new Swiper(swiperEl, options);
			swiperEl.swiper = swiper;
			
			// CRITICAL: Remove custom touch-action and let Swiper handle it
			swiperEl.style.touchAction = ''; // Remove custom touch-action
			
			// OR if you need to keep it, use pan-y (not pan-x):
			// swiperEl.style.touchAction = 'pan-y pinch-zoom';
			
			swiperEl.style.webkitOverflowScrolling = 'touch';
			
			// Add these styles for better performance
			swiperEl.style.willChange = 'transform';
			
			if (typeof ResizeObserver !== 'undefined') {
				var lastW = 0;
				var roTimer = null;
				var ro = new ResizeObserver(function () {
					var cw = swiperEl.clientWidth;
					if (Math.abs(cw - lastW) < 2) return;
					lastW = cw;
					if (roTimer) clearTimeout(roTimer);
					roTimer = setTimeout(function () {
						roTimer = null;
						if (!swiperEl.swiper) return;
						
						equalizedHeightsMap.delete(swiperEl);
						heightAppliedMap.set(swiperEl, false);
						equalizeClubCardHeights(swiperEl.swiper, true);
					}, 250);
				});
				ro.observe(swiperEl);
				if (resizeObservers) resizeObservers.set(swiperEl, ro);
			}
		}

		mountWhenLaidOut();
	}

	function initClubCardsSliders() {
		if (typeof Swiper === 'undefined') return;
		document.querySelectorAll('.club-cards-slider-section .club-cards-slider__swiper').forEach(initOneSwiper);
	}

	function runWhenReady() {
		if (typeof Swiper !== 'undefined') {
			initClubCardsSliders();
			return;
		}
		var attempts = 0;
		var id = setInterval(function () {
			attempts += 1;
			if (typeof Swiper !== 'undefined') {
				clearInterval(id);
				initClubCardsSliders();
			} else if (attempts > 100) {
				clearInterval(id);
			}
		}, 50);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', runWhenReady);
	} else {
		runWhenReady();
	}

	document.addEventListener('shopify:section:load', function (ev) {
		var root = ev.target;
		if (!root || !root.classList || !root.classList.contains('club-cards-slider-section')) return;
		var el = root.querySelector('.club-cards-slider__swiper');
		if (el && typeof Swiper !== 'undefined') {
			initOneSwiper(el);
		}
	});

	document.addEventListener('shopify:section:unload', function (ev) {
		var root = ev.target;
		if (!root || !root.querySelector) return;
		var el = root.querySelector('.club-cards-slider__swiper');
		if (!el) return;
		if (resizeObservers && resizeObservers.has(el)) {
			resizeObservers.get(el).disconnect();
			resizeObservers.delete(el);
		}
		if (el.swiper) {
			el.swiper.destroy(true, true);
		}
	});
})();